import { ActionGoToWebProjects, isProjectId, PROJECTS } from '@wg/web2clientapi/browser/goToWebProject';
import { setOnCloseActionsQueue } from '@wg/web2clientapi/browser/setOnCloseActionsQueue';

interface ReturnNavigation {
  projectId: PROJECTS;
  path: string;
}

type OnCloseAction = ActionGoToWebProjects;

let onCloseActionsQueue: OnCloseAction[] = [];

const syncActionsQueue = () => {
  setOnCloseActionsQueue(onCloseActionsQueue);
};

export const removeActionsFromQueue = (predicate: (action: OnCloseAction) => boolean) => {
  onCloseActionsQueue = onCloseActionsQueue.filter((action) => !predicate(action));
  syncActionsQueue();
};

const addActionToQueue = (action: OnCloseAction) => {
  onCloseActionsQueue.push(action);
  syncActionsQueue();
};

const getReturnNavigation = (search: string): ReturnNavigation | null => {
  const params = new URLSearchParams(search);

  const projectIdRaw = params.get('returnProject');
  if (!isProjectId(projectIdRaw)) {
    return null;
  }

  const path = params.get('returnPathname') ?? '';

  return { projectId: projectIdRaw, path };
};

export const enqueueReturnNavigationOnClose = (search: string) => {
  const nav = getReturnNavigation(search);
  if (!nav) {
    return;
  }

  addActionToQueue({
    actionId: 'goToWebProject',
    ...nav,
  });
};
